import {
    Directive,
    Optional,
    ElementRef,
    Inject,
    AfterViewInit,
    Self,
    EventEmitter,
    HostBinding,
    HostListener
} from '@angular/core';

import { TIME_MERIDIEM, TIME_TIMEZONE_STRING } from '../interfaces/Tokens';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({
    selector: 'anj-input[anjTimePicker]',
    exportAs: 'anjTimepickerInput'
})
export class TimePickerDirective implements AfterViewInit, ControlValueAccessor {
    public readonly valueChange: EventEmitter<string | null>;

    @HostBinding('value') public value: string;

    constructor(private _element: ElementRef,
                @Optional() @Self() private ngControl?: NgControl,
                @Optional() @Inject(TIME_TIMEZONE_STRING) private _timezone?: string,
                @Optional() @Inject(TIME_MERIDIEM) private _meridiem?: boolean) {
        this.valueChange = new EventEmitter<string | null>();

        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngAfterViewInit() {
       const picker = this._element.nativeElement.querySelector('anj-time-picker');

       picker.setAttribute('meridiem', this._meridiem);

       if (this._timezone) {
           picker.setAttribute('timezone', this._timezone);
       }
    }

    // // Start: ControlValueAccessor requirements
    public writeValue(newValue: string): void {
        this.value = newValue;
    }

    public onChange: (value: any) => void = () => {/**/};
    public onTouch: () => void = () => {/**/};

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }
    // // End: ControlValueAccessor requirements

    @HostListener('anjClockSelection', ['$event'])
    public onInput(event: any) {

        this.value = event.detail;
        if (this.ngControl) {
            this.ngControl.control.setValue(this.value);
        }

        this.valueChange.emit(this.value);
    }
}
